// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"74d7bf32194ac182c24d","293":"d86683613e179ec80faa","518":"c11688846f18b5825027","779":"600ee7a0d71ba0e34d92"}[chunkId] + ".js";
};